import {Button} from "@progress/kendo-react-buttons"
import {useInternationalization} from "@progress/kendo-react-intl"
import {ListView, ListViewHeader, ListViewItemProps} from "@progress/kendo-react-listview"
import { Spinner } from "@volvo/vcdk-react/Spinner";
import {Dispatch, SetStateAction} from "react"
import {useDispatch} from "react-redux"
import {Link} from "react-router-dom"
import {refreshRecentAnnualTests, setSelectedNavAction} from "../../containers/App/appSlice"
import {RecentMot} from "../../containers/App/models"
import {RootState} from "../../rootReducer"
import {useAppSelector} from "../../store"

const MotHistoryList = ({
    vehicleRegNo,
    showSearchBox,
    focusOnSearch,
}: {
    vehicleRegNo: string
    showSearchBox: Dispatch<SetStateAction<boolean>>
    focusOnSearch: () => void
}) => {
    const dispatch = useDispatch()
    const vehicleDetail = useAppSelector((state: RootState) => state.application.searchedVehicle)
    const recentMotTests = useAppSelector((state: RootState) => state.application.recentMot)
    const loading = useAppSelector((state: RootState) => state.application.loadingRecentMOT)

    const refreshMOTHistory = () => {
        dispatch(refreshRecentAnnualTests(vehicleRegNo))
        focusOnSearch()
    }

    const MOTHeader = () => {
        return (
            <ListViewHeader style={{color: "rgb(160, 160, 160)", fontSize: 14}}>
                <div className="d-flex justify-content-between align-items-center border-bottom pb-1 pt-1">
                    <h4 style={{fontSize: 12, color: "#434343", marginBottom: 0}} className="font-weight-bold">
                        Mot History
                    </h4>
                    {/* <div className="search-header-line"></div> */}
                    <Button
                        type="button"
                        fillMode="link"
                        themeColor={"primary"}
                        size="small"
                        title="Refresh"
                        icon="refresh"
                        disabled={loading}
                        onClick={refreshMOTHistory}
                    ></Button>
                </div>
                <div className="w-100 d-flex justify-content-around mb-2 mt-2">
                    {loading && (
                         <Spinner size="medium"  />
                    )}
                    {vehicleDetail && !loading && recentMotTests.length === 0 && (
                        <div style={{fontSize: 12, color: "#a0a0a0"}}>No data found</div>
                    )}
                </div>
            </ListViewHeader>
        )
    }

    const MOTItemRender = (props: ListViewItemProps) => {
        const intl = useInternationalization()
        let item = props.dataItem as RecentMot

        const navigateToMot = () => {
            showSearchBox(false)
            dispatch(setSelectedNavAction("/mot"))
        }

        return (
            <Link to={`/mot?vid=${item.vehicleId}&&registration=${vehicleRegNo}`} onClick={navigateToMot}>
                <div className="search-list-item align-middle border-bottom" style={{margin: 0}}>
                    <div className="d-flex justify-content-between align-items-center">
                        <div>{intl.formatDate(new Date(item.testDate))}</div>
                        <div>{item.motNumber}</div>
                    </div>
                    <div
                        style={{fontSize: 12}}
                        className={`font-weight-bold text-${item.status === "PASSED" ? "success" : "danger"}`}
                    >
                        {item.status}
                    </div>
                </div>
            </Link>
        )
    }

    return (
        <>
            <ListView
                data={recentMotTests}
                item={MOTItemRender}
                style={{width: "100%", minHeight: "300px"}}
                header={MOTHeader}
            />
        </>
    )
}

export default MotHistoryList
